import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

export const Slide2 = ({ t, total, onActive }) => {
  return (
    <SlideShell theme="emissor"
      index={1}
      total={total}
      label="Core Idea"
      kicker={t.kicker}
      onActive={onActive}
      bgStyle={{
        "--slide-bg": "radial-gradient(650px 480px at 70% 38%,rgba(215,184,46,.21),transparent 68%),linear-gradient(120deg,#020403,#07120e 50%,#020202)"
      }}
    >

      <div className="split">
        <div>
          
          <h2>{t.title}</h2>
          <p className="lead">{t.body}</p>
          <div className="grid two">
            <div className="card">
              <span className="num">{t.c1Num}</span>
              <h3>{t.c1Title}</h3>
              <p>{t.c1Body}</p>
            </div>
            <div className="card">
              <span className="num">{t.c2Num}</span>
              <h3>{t.c2Title}</h3>
              <p>{t.c2Body}</p>
            </div>
          </div>
        </div>
        <div
          className="image-card"
          style={{
            "--image-bg": "linear-gradient(145deg,rgba(216,182,46,.28),rgba(4,12,10,.15)), repeating-linear-gradient(90deg,rgba(255,255,255,.12) 0 1px,transparent 1px 50px), repeating-linear-gradient(0deg,rgba(216,182,46,.16) 0 1px,transparent 1px 50px)"
          }}
        >
          <div className="caption">
            <div className="eyebrow">{t.imgEyebrow}</div>
            <h3>{t.imgTitle}</h3>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


